import { render, staticRenderFns } from "./DialogScoredGameGroupDetails.vue?vue&type=template&id=df8e86c8&scoped=true"
import script from "./DialogScoredGameGroupDetails.js?vue&type=script&lang=js&external"
export * from "./DialogScoredGameGroupDetails.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8e86c8",
  null
  
)

export default component.exports